<script>
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import sl from "@/Prevodi/Jezik-sl.json";
import en from "@/Prevodi/Jezik-en.json";
import it from "@/Prevodi/Jezik-it.json";
export default {
  components: {
    Notification,
  },
  props: {
    UserID: String,
    FullUser: Object,
  },
  data() {
    return {
      prevodi: false,
      showSettings: false,
      izbranJezik: '',
      changes: false,
      ShowNoti: false,
      text: '',
      types: '',
      jeziki: [
        {
          "id": "sl",
          "jezik": "Slovenski"
        },
        {
          "id": "en",
          "jezik": "English"
        },
        {
          "id": "it",
          "jezik": "Italiano"
        }
      ],
    }
  },
  created() {
    // await this.loadTranslations('sl', './src/prevodi/Jezik-sl.json');
    // await this.loadTranslations('en', './src/prevodi/Jezik-en.json');
    // await this.loadTranslations('it', './src/prevodi/Jezik-it.json');
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
    this.izbranJezik = this.$i18n.locale;
  },
  methods: {
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    OpenSettings() {
      this.showSettings = !this.showSettings;
    },
    SetLanguage() {
      this.changes = true;
      this.text = this.$t('obvestila.vprasanjeMenjave');
      this.types = 'Vprašanje';
      this.ShowNoti = true;
    },
    ConfirmChange() {
      var podatki = new URLSearchParams();
      podatki.append('jezik', this.izbranJezik);
      axios.post('./api/nastavitve/jezik/', podatki, {withCredentials: true}).then((response) => {
        this.changeLang(this.izbranJezik);
        this.text = this.$t('obvestila.uspesno');
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.changes = false;
        this.OpenSettings();
      }).catch((napaka) => {
        this.text = this.$t('obvestila.uspesno');
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.changes = false;
      })
    },
  }
}
</script>
<template>
  <!--       <div class="drop-down-icon text-black" @click.prevent="OpenSettings()">
          <i v-show="!showSettings" class="fas fa-chevron-right"></i>
          <i v-show="showSettings" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSettings()">{{$t('labels.buttons.odpriJezik')}}</button> -->
  <transition name="fade">
    <div class="container p-2 gap-2 d-flex justify-content-center">
      <div class="container row">
        <div class="modern-section-body">
          <div class="modern-form-group text-center">
            <label class="modern-form-label">{{$t('labels.izberi')}}</label>
            <select class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5 text-center" v-model="izbranJezik">
              <option v-for="jezik in jeziki" :value="jezik.id">[{{jezik.id.toUpperCase()}}] {{jezik.jezik}}</option>
            </select>
            <div class="modern-form-actions">
              <button type="button"
                      class="btn btn-primary"
                      @click.prevent="SetLanguage()"
                      :disabled="changes">
                <i class="fas fa-check"  v-if="!changes"></i>
                <i class="fas fa-language fa-spin" v-if="changes"></i>
                &nbsp;
                <span v-if="changes"> {{$t('labels.buttons.generiranje')}}</span>
                <span v-else> {{$t('labels.buttons.potrdiJezik')}}</span>

              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <Transition name="fade">
    <Notification class="top-0" v-if="ShowNoti" :message="this.text" :type="this.types"  @da="ConfirmChange()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>